import StarWhiteSVG from './star-white.svg';
import GoogleWhiteSVG from './google-white.svg';
import LockWhiteSVG from './lock-white.svg';
import CheckSVG from './check.svg';
import InfoSVG from './info.svg';
import PlaySVG from './play.svg';
import StarYellowSmallSVG from './star-yellow-small.svg';
import StarYellowSVG from './star-yellow.svg';
import YoutubeSVG from './youtube.svg';
import EmailSVG from './email.svg';
import LockInputSVG from './lock-input.svg';
import MoreSVG from './more.svg';
import PlusIconSVG from './plus-icon.svg';
import DashIconSVG from './dash-icon.svg';
import StrokeLineSVG from './stroke-line.svg';
import TickGreenSVG from './tick-green.svg';
import MenuSVG from './menu.svg';
import CloseSVG from './close.svg';
import ExternalLinkSVG from './external-link.svg';
import MenuMobileSVG from './menu-mobile.svg';
import DropdownSVG from './dropdown.svg';
import PlaydownIconSVG from './play-down.svg';
import ArrowLeft from './arrow-left.svg';
import OpenTab from './open-tab.svg';
import CloseTab from './close-tab.svg';
import CloseGreySVG from './close-grey.svg';

export {
    StarWhiteSVG,
    GoogleWhiteSVG,
    LockWhiteSVG,
    CheckSVG,
    InfoSVG,
    PlaySVG,
    StarYellowSmallSVG,
    StarYellowSVG,
    YoutubeSVG,
    EmailSVG,
    LockInputSVG,
    MoreSVG,
    PlusIconSVG,
    DashIconSVG,
    StrokeLineSVG,
    TickGreenSVG,
    MenuSVG,
    CloseSVG,
    ExternalLinkSVG,
    MenuMobileSVG,
    DropdownSVG,
    PlaydownIconSVG,
    ArrowLeft,
    CloseTab,
    OpenTab,
    CloseGreySVG,
};
